<template>
  <wb-tag class="emh-ui-tag" :variant.attr="variant" @click="mobileOnRemove">
    <wb-icon
      v-if="removable"
      :name.attr="'close'"
      aria-hidden="true"
      class="emh-ui-tag__remove-button"
      @click.stop="onRemove"
    />
    <wb-icon v-if="icon" class="wb-tag__icon" aria-hidden="true" flip-rtl :name.attr="icon" />
    <slot />
  </wb-tag>
</template>

<script lang="ts">
export default { name: 'UiTag' };
</script>

<script lang="ts" setup>
import { PropType } from 'vue';
import { useBreakpoint } from '@dh-io-emh/shared/src/composables/breakpoint.composable';

defineProps({
  removable: { type: Boolean, default: false },
  icon: { type: String, default: '' },
  variant: { type: String as PropType<'primary' | 'secondary' | 'tertiary'>, default: 'primary' },
});

const emit = defineEmits(['remove']);

const { isMobile } = useBreakpoint();

const mobileOnRemove = () => {
  if (isMobile.value) {
    onRemove();
  }
};

const onRemove = () => {
  emit('remove');
};
</script>

<style lang="scss" scoped>
.emh-ui-tag {
  display: flex;
  justify-content: center;
  align-items: center;

  &__remove-button {
    cursor: pointer;
    padding: 8px;
    margin: -4px 0 -4px -6px;
  }
}
</style>
